
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/call-us",
      function () {
        return require("private-next-pages/call-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/call-us"])
      });
    }
  